import React from "react";
import Sidebar from "../../components/Sidebar";
import AnnouncementsPanel from "./components/AnnouncementsPanel";

const Announcements = () => {
  return (
    <div className="flex overflow-hidden flex-col h-screen md:flex-row">
      <Sidebar />

      <div className="overflow-y-auto flex-1 p-4 bg-white md:py-7">
        <h1 className="py-4 mb-0 text-xl font-bold md:text-2xl md:mb-6">Announcements</h1>
        <AnnouncementsPanel />
      </div>
    </div>
  );
};

export default Announcements;
